// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomColorInput_container__1DnTe","input":"CustomColorInput_input__1G72F","button":"CustomColorInput_button__1IL1o"};